import "./link-list.scss";

document.addEventListener("DOMContentLoaded", () => {
  const cards = document.querySelectorAll(".link-list__item");
  if(cards) {
    cards.forEach((card) => {
      const image = card.querySelector(".link-list__img-wrapper");
      const cta = card.querySelector(".link-list__item-link");
      if(image) {
        image.addEventListener("click", (event) => {
          event.preventDefault();
          event.stopPropagation();
          cta.click();
        });
      }
    });
  }
});
